import { gql } from '@grandvisionhq/graphql';

const productFragment = gql`
  fragment productFragment on Product {
    brand
    description
    isPublished
    isReviewEnabled
    metaDescription
    metaTitle
    name
    productType
    slug
    categories {
      name
    }
    ratingsSummary {
      average
      reviewCount
    }
    taxCategory {
      key
      rate {
        amount
        id
      }
    }
  }
`;

export { productFragment };
//# sourceMappingURL=product.js.map
